export class FilterUsedLabelsCount {

	static selector = '.js-filter__labels-count';

	filter;
	node;
	labels = [];

	constructor(node) {
		if (! node) {
			throw new Error('Missing node node for used filters in filter.');
		}

		this.node = node;
		this.render();
	}

	render() {
		let self = this;
		self.node.dataset.count = self.labels.length + '';
		self.node.innerHTML = self.labels.length;
	}

	setLabels(labels) {
		let self = this;

		self.labels = labels;
		this.render();
	}
}
